import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { configHelper } from '@ilteducation/config';
import axios from 'axios';
import { RelatedContentItem } from './types';

const contentMatchingUrl = configHelper.getApiUrl('content-matching', true);

const useSimilarContentsStore = defineStore('similar-contents', () => {
  const similarContentItems = ref<Record<string, RelatedContentItem[]>>({});
  const loadedContents = ref<Record<string, boolean>>({});
  const isLoadingByContextKey = ref<Record<string, boolean>>({});

  const loadedKey = (contentId: string, contentItemType?: string): string => `${contentId}:${contentItemType}`;

  const getSimilarContentItems = computed(
    () => (contentId: string, contentItemType?: string) =>
      similarContentItems.value[loadedKey(contentId, contentItemType)],
  );

  const load = async (contentId: string, contentItemType?: string): Promise<void> => {
    const loadedCheckKey = loadedKey(contentId, contentItemType);
    if (loadedContents.value[loadedCheckKey]) {
      return;
    }

    const response = await axios.get(
      `${contentMatchingUrl}/search?ids=${contentId}${contentItemType ? `&contentItemType=${contentItemType}` : ''}`,
    );

    similarContentItems.value[loadedCheckKey] = response.data;
    loadedContents.value[loadedCheckKey] = true;
  };

  const similarContentItemsByContextKey = ref<Record<string, RelatedContentItem[]>>({});

  const loadMultiple = async (contentIds: string[], contextKey: string, contentItemType?: string): Promise<void> => {
    if (similarContentItemsByContextKey.value[contextKey]) {
      return;
    }

    const response = await axios.get(
      `${contentMatchingUrl}/search?ids=${contentIds.join(',')}${
        contentItemType ? `&contentItemType=${contentItemType}` : ''
      }`,
    );

    similarContentItemsByContextKey.value[contextKey] = response.data;
  };

  return {
    similarContentItemsByContextKey,
    loadedKey,
    getSimilarContentItems,
    load,
    loadMultiple,
    isLoadingByContextKey,
  };
});

export default useSimilarContentsStore;
